import React, { useState, useEffect } from "react";
import { MdEdit } from "react-icons/md";
import { CgCloseR } from "react-icons/cg";
import EditCommunityDetails from "./EditCommunityDetails/EditCommunityDetails";
import AddHome from "./AddHome/AddHome";
import EditHome from "./EditHome/EditHome";
import BankDetails from "./BankDetails/BankDetails";
import { useDispatch, useSelector } from "react-redux";
import { GrStatusInfo } from 'react-icons/gr';
import { useHistory } from 'react-router-dom';
import { Search, X, Eye, Pencil, Trash2 } from "lucide-react";
import Loading from "../../component/Loading/Loading";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { MdDeleteForever } from "react-icons/md";
import { setCommunityId } from "../../redux/authSlice";
import { AiOutlineSortAscending } from "react-icons/ai";
import { AiOutlineSortDescending } from "react-icons/ai";
import Pagination from "../../utils/Pagenation/Pagenation";
import MonthlyFees from "../MonthlyFees/MonthlyFees";
import useAxiosInstance from "../../services/useAxiosInstance";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";
import Project from "./Projects/Project";

const CommunityDetails = () => {
  const axiosInstance = useAxiosInstance();
  const [activeStatusSet, setActiveStatusSet] = useState();
  const roleIds = useSelector(state => state.auth.roleId);
  const dispatch = useDispatch();
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

  const communityId = useSelector((state) => state.auth.communityId);
  const userId = useSelector((state) => state.auth.userId);
  const [searchQuery, setSearchQuery] = useState("");
  const [communityData, setCommunityData] = useState(null);
  const [userData, setUserData] = useState([]);
  const history = useHistory();
  const [contractCode, setContractCode] = useState(null);
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const filteredData = userData.filter((item) =>
    item.firstName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const fetchCommunityData = async () => {
    setLoading(true);
    try {
      const communityResponse = await axiosInstance.get(`/api/public/community/getOne/${communityId}`);
      const communityData = communityResponse.data;
      setCommunityData(communityData);

      const contractId = communityData.contractId;

      const contractResponse = await axiosInstance.get(`/api/public/contract/getOne/${contractId}`);
      const contractData = contractResponse.data;
      setContractCode(contractData.contractcode);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommunityData();
  }, [communityId]);


  const [showcommunityForm, setShowcommunityForm] = useState(false);
  const handleAddcommunityClick = () => {
    setLoading(true);
    setShowcommunityForm(!showcommunityForm);
    setLoading(false);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingUserId, setDeletingUserId] = useState(null);


  const handleDeleteClick = (userId) => {
    setDeletingUserId(userId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeletingUserId(null);
  };


  const handleDeleteUser = async () => {
    try {
      setLoading(true);

      await axiosInstance.delete(`/api/public/community/${deletingUserId}`);

      setShowDeleteModal(false);
      setDeletingUserId(null);
      fetchUsers();
      setAlert({ visible: true, message: 'User deleted successfully!', type: 'success' });
    } catch (error) {
      console.error("Error deleting user:", error);
      setAlert({ visible: true, message: 'Error deleting user: Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };


  function formatDate(dateString) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }

  const [showAddHome, setShowAddHome] = useState(false);
  const handleAddHomeClick = (e) => {
    setLoading(true);
    e.preventDefault();
    setShowAddHome(!showAddHome);
    setLoading(false);
  };

  const [showEditHome, setShowEditHome] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [editingAddressId, setEditingAddressId] = useState(null);

  const handleEditHomeClick = (userId, addressId) => {
    setLoading(true);
    setEditingUserId(userId);
    setEditingAddressId(addressId);
    setShowEditHome(true);
    setLoading(false);
  };

  const handleHideEditHome = () => {
    setShowEditHome(false);
    setLoading(true);
    fetchCommunityData();
    fetchUsers();
  };

  const handleEditCommunityDetails = (updatedData) => {
    setLoading(true);
    setCommunityData(updatedData);
    setShowcommunityForm(false);
    setLoading(false);
  };

  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const [formData, setFormData] = useState({
    communityName: "",
    address: "",
    contact: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e, name) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const communityResponse = await axiosInstance.get(`/api/public/community/getOne/${communityId}`);
        const communityData = communityResponse.data;
        setCommunityData(communityData);

        const contractId = communityData.contractId;

        const contractResponse = await axiosInstance.get(`/api/public/contract/getOne/${contractId}`);
        const contractData = contractResponse.data;
        setContractCode(contractData.contractcode);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [communityId]);


  const [emails, setEmails] = useState({
    presidentEmail: "",
    secretaryEmail: "",
    treasurerEmail: "",
    hoaAdminEmail: "",
  });

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInvite = (role, position, email) => {
    setLoading(true);

    if (!contractCode) {
      console.error("Contract code is not available");
      setAlert({ visible: true, message: 'Contract code is not available. Please check and try again.', type: 'error' });
      setLoading(false);
      return;
    }

    if (!isValidEmail(email)) {
      console.error("Invalid email address");
      setAlert({ visible: true, message: 'Invalid email address. Please enter a valid email.', type: 'error' });
      setLoading(false);
      return;
    }

    const invitationData = {
      boardMemberRole: position,
      clientEmail: email,
      clientName: null,
      contractCode: contractCode,
      roleId: parseInt(role),
    };

    axiosInstance
      .post(
        `/api/public/emailInvitation/send-invitation-To-The-Other-BoardMember`,
        invitationData,)
      .then((response) => {
        setAlert({ visible: true, message: (`Invitation sent successfully to ${email}`), type: 'success' });
      })
      .catch((error) => {
        console.error("Error sending invitation:", error);
        setAlert({ visible: true, message: (`Failed to send invitation to ${email}. Please try again.`), type: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const [loading, setLoading] = useState(false);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/api/user/getUsersList/${communityId}`);
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [communityId]);

  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [editMemberRoleModal, SetEditMemberRoleModal] = useState(false);

  const [selectedUserId, setSelectedUserId] = useState(null);

  const openApprovalModal = (userId, activeStatus) => {
    setLoading(true);
    setActiveStatusSet(activeStatus);
    setSelectedUserId(userId);
    setShowApprovalModal(true);
    setLoading(false);
  };

  const goBack = () => {
    window.history.back();
    if (roleIds === 1000) {
      dispatch(setCommunityId(null));
    }
  };

  const closeModal = () => {
    setShowApprovalModal(false);
    SetEditMemberRoleModal(false);
  };

  const handleUpdateStatus = async (status) => {
    setShowApprovalModal(false);
    setActiveStatusSet(status);

    try {
      setLoading(true);

      const response = await axiosInstance.patch(
        `/api/user/${selectedUserId}/status?activeStatus=${status}`);

      if (response.status === 200) {
        fetchUsers();
        setAlert({ visible: true, message: 'User status updated successfully!', type: 'success' });
      } else {
        const errorText = response.data;
        console.error("Error response:", errorText);
      }
    } catch (error) {
      console.error("An error occurred while updating user status", error);
      setAlert({ visible: true, message: 'An error occurred while updating user status: Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const [newEmailId, setNewEmailId] = useState('');
  const [newUserId, setNewUserId] = useState('');

  const openeditMemberRoleModal = (role) => {
    setLoading(true);
    setSelectedRole(role);
    SetEditMemberRoleModal(true);
    setLoading(false);
  };
  const [selectedRole, setSelectedRole] = useState('');

  const handleUpdateBoardMemberRole = async () => {
    setLoading(true);

    try {
      SetEditMemberRoleModal(false);

      const response = await axiosInstance.patch(`/api/public/community/updateRole/${communityId}`,
        null,
        {
          params: {
            communityId: communityId,
            newEmailId: newEmailId,
            newUserId: newUserId,
            role: selectedRole,
          },
        }
      );

      console.log('Response:', response.data);
      setAlert({ visible: true, message: 'Community role updated successfully!', type: 'success' });
      SetEditMemberRoleModal(false);
      fetchUsers();
      fetchCommunityData();

    } catch (error) {
      console.error('There was an error updating the Community role!', error);
      setAlert({ visible: true, message: 'There was an error updating the Community role!', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const [isSortedAsc, setIsSortedAsc] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const handleSort = () => {
    setIsSortedAsc((prev) => (prev === true ? false : prev === false ? null : true));
  };

  const sortedData = (() => {
    if (isSortedAsc === null) {
      return filteredData;
    }
    return [...filteredData].sort((a, b) => {
      const nameA = a.firstName.toLowerCase();
      const nameB = b.firstName.toLowerCase();

      if (nameA < nameB) return isSortedAsc ? -1 : 1;
      if (nameA > nameB) return isSortedAsc ? 1 : -1;
      return 0;
    });
  })();

  const pageCount = Math.ceil(sortedData.length / itemsPerPage);
  const currentPageData = sortedData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // Modal footers
  const deleteModalFooter = (
    <div className="flex justify-end space-x-2">
      <button
        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        onClick={closeDeleteModal}
      >
        Cancel
      </button>
      <button
        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
        onClick={handleDeleteUser}
      >
        Delete
      </button>
    </div>
  );

  const approvalModalFooter = (
    <div className="flex justify-end space-x-2">
      <button
        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        onClick={closeModal}
      >
        Cancel
      </button>
      {activeStatusSet === "true" ? (
        <button
          className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
          onClick={() => handleUpdateStatus(false)}
        >
          Deactivate
        </button>
      ) : (
        <button
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          onClick={() => handleUpdateStatus(true)}
        >
          Activate
        </button>
      )}
    </div>
  );

  const memberRoleModalFooter = (
    <div className="flex justify-end space-x-2">
      <button
        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        onClick={closeModal}
      >
        Cancel
      </button>
      <button
        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
        onClick={handleUpdateBoardMemberRole}
      >
        Remove
      </button>
    </div>
  );

  return (
    <div className="bg-gray-50 min-h-screen p-4">
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}

          <div className="flex border-b border-gray-200 mb-4">
            <div
              className={`py-4 px-6 text-center cursor-pointer select-none hover:bg-gray-100 ${activeTab === 0 ? "border-b-2 border-blue-500 text-blue-700 font-medium" : "text-gray-700"}`}
              onClick={() => handleTabClick(0)}
            >
              Community Details
            </div>
            <div
              className={`py-4 px-6 text-center cursor-pointer select-none hover:bg-gray-100 ${activeTab === 1 ? "border-b-2 border-blue-500 text-blue-700 font-medium" : "text-gray-700"}`}
              onClick={() => handleTabClick(1)}
            >
              Bank Details
            </div>
            <div
              className={`py-4 px-6 text-center cursor-pointer select-none hover:bg-gray-100 ${activeTab === 3 ? "border-b-2 border-blue-500 text-blue-700 font-medium" : "text-gray-700"}`}
              onClick={() => handleTabClick(3)}
            >
              Projects
            </div>
            {/* <div
              className={`py-4 px-6 text-center cursor-pointer select-none hover:bg-gray-100 ${activeTab === 2 ? "border-b-2 border-blue-500 text-blue-700 font-medium" : "text-gray-700"}`}
            >
              Community Website
            </div> */}
            <a
              href="https://berkshirecommunity.netlify.app"
              target="_blank"
              className={`py-4 px-6 text-center cursor-pointer select-none hover:bg-gray-100 ${activeTab === 2 ? "border-b-2 border-blue-500 text-blue-700 font-medium" : "text-gray-700"}`}
            >
              Community Website
            </a>
          </div>

          {activeTab === 0 && (
            <>
              <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Community Details</h1>
                <button
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  onClick={goBack}
                >
                  Back
                </button>
              </div>

              <div className="flex flex-wrap gap-6 mb-6">
                {communityData && (
                  <div className="w-full lg:w-[calc(60%-1.5rem)] bg-white rounded-lg shadow-sm p-4">
                    <div className="divide-y divide-gray-200">
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Name</p>
                        <p className="text-gray-800">{communityData.name}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Contact Person</p>
                        <p className="text-gray-800">{communityData.contactPerson}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Total Owners</p>
                        <p className="text-gray-800">{communityData.communitySize}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Community Code</p>
                        <p className="text-gray-800">{communityData.communityCode}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Business Address</p>
                        <p className="text-gray-800">{communityData.address.address}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">City</p>
                        <p className="text-gray-800">{communityData.address.city}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Plan Period</p>
                        <p className="text-gray-800">{communityData.plan.planPeriod.planPeriod}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Plan Range</p>
                        <p className="text-gray-800">{communityData.plan.planRange.planRange}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Plan Type</p>
                        <p className="text-gray-800">{communityData.plan.planType.planType}</p>
                      </div>
                      <div className="py-3 flex justify-between">
                        <p className="font-medium text-gray-700">Expire Date</p>
                        <p className="text-gray-800">{formatDate(communityData.planExpireDate)}</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="w-full lg:w-[calc(40%)] bg-white rounded-lg shadow-sm">
                  <div className="border-b border-gray-200 p-4">
                    <h3 className="font-medium text-gray-800">Board Members</h3>
                  </div>

                  {communityData && (
                    <div className="p-4 divide-y divide-gray-200">
                      <div className="py-3">
                        <p className="font-medium text-gray-700 mb-2">President</p>
                        {communityData.presidentInviteStatus === null && (
                          <div className="flex gap-2">
                            <input
                              type="email"
                              name="presidentEmail"
                              placeholder="Enter president email"
                              value={emails.presidentEmail}
                              onChange={(e) => setEmails({ ...emails, presidentEmail: e.target.value })}
                              className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                              onClick={() => handleInvite('1002', 'president', emails.presidentEmail)}
                            >
                              Invite
                            </button>
                          </div>
                        )}
                        {(communityData.presidentInviteStatus === "invited" || communityData.presidentInviteStatus === "approved") && (
                          <div className="flex justify-between items-center">
                            <p className="text-gray-800">{communityData.presidentEmailID}</p>
                            {roleIds === 1001 && (
                              <button
                                className="text-red-500 hover:text-red-700"
                                onClick={() => openeditMemberRoleModal('president')}
                              >
                                <MdDeleteForever size={20} />
                              </button>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="py-3">
                        <p className="font-medium text-gray-700 mb-2">Secretary</p>
                        {communityData.secretaryInviteStatus === null && (
                          <div className="flex gap-2">
                            <input
                              type="email"
                              name="secretaryEmail"
                              placeholder="Enter secretary email"
                              value={emails.secretaryEmail}
                              onChange={(e) => setEmails({ ...emails, secretaryEmail: e.target.value })}
                              className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                              onClick={() => handleInvite('1002', 'secretary', emails.secretaryEmail)}
                            >
                              Invite
                            </button>
                          </div>
                        )}
                        {(communityData.secretaryInviteStatus === "invited" || communityData.secretaryInviteStatus === "approved") && (
                          <div className="flex justify-between items-center">
                            <p className="text-gray-800">{communityData.secretaryEmailID}</p>
                            {roleIds === 1001 && (
                              <button
                                className="text-red-500 hover:text-red-700"
                                onClick={() => openeditMemberRoleModal('secretary')}
                              >
                                <MdDeleteForever size={20} />
                              </button>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="py-3">
                        <p className="font-medium text-gray-700 mb-2">Treasurer</p>
                        {communityData.treasurerInviteStatus === null && (
                          <div className="flex gap-2">
                            <input
                              type="email"
                              name="treasurerEmail"
                              placeholder="Enter treasurer email"
                              value={emails.treasurerEmail}
                              onChange={(e) => setEmails({ ...emails, treasurerEmail: e.target.value })}
                              className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                              onClick={() => handleInvite('1002', 'treasurer', emails.treasurerEmail)}
                            >
                              Invite
                            </button>
                          </div>
                        )}
                        {(communityData.treasurerInviteStatus === "invited" || communityData.treasurerInviteStatus === "approved") && (
                          <div className="flex justify-between items-center">
                            <p className="text-gray-800">{communityData.treasurerEmailID}</p>
                            {roleIds === 1001 && (
                              <button
                                className="text-red-500 hover:text-red-700"
                                onClick={() => openeditMemberRoleModal('treasurer')}
                              >
                                <MdDeleteForever size={20} />
                              </button>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="py-3">
                        <p className="font-medium text-gray-700 mb-2">HOA Admin</p>
                        {communityData.adminInviteStatus === null && (
                          <div className="flex gap-2">
                            <input
                              type="email"
                              name="hoaAdminEmail"
                              placeholder="Enter HOA admin email"
                              value={emails.hoaAdminEmail}
                              onChange={(e) => setEmails({ ...emails, hoaAdminEmail: e.target.value })}
                              className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                              onClick={() => handleInvite('1001', 'admin', emails.hoaAdminEmail)}
                            >
                              Invite
                            </button>
                          </div>
                        )}
                        {communityData.adminInviteStatus === "invited" && (
                          <div className="flex justify-between items-center">
                            <p className="text-gray-800">{communityData.adminEmailID}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                <MonthlyFees />
              </div>

              <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                  <h2 className="text-lg font-medium text-gray-800">Homeowner Details</h2>
                </div>

                <div className="">
                  <div className="flex items-center mb-4 p-4">
                    <div className="relative w-full md:w-80">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <Search className="h-5 w-5 text-gray-400" />2
                      </div>
                      <input
                        type="text"
                        placeholder="Search Homeowners"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                  </div>

                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-blue-400">
                        <tr>
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                            First Name  <button
                              onClick={handleSort}
                            >
                              {isSortedAsc === true ? (
                                <AiOutlineSortAscending className="inline ml-1" />
                              ) : isSortedAsc === false ? (
                                <AiOutlineSortDescending className="inline ml-1" />
                              ) : (
                                <AiOutlineSortAscending className="inline ml-1" />
                              )}
                            </button>
                          </th>
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                            Mobile Number
                          </th>
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                            Role
                          </th>
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                            Email
                          </th>
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                            Status
                          </th>
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {currentPageData.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">
                              No Data Found
                            </td>
                          </tr>
                        ) : (
                          currentPageData.map((item, index) => (
                            <tr key={item.id} className={index % 2 === 1 ? "bg-gray-50" : ""}>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {item.firstName}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {item.mobileNumber}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {item.roleName}
                              </td>
                              {/*<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">*/}
                              {/*  {item.emailId}*/}
                              {/*</td>*/}
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {item.emailId
                                  ?.match(/.{1,25}/g)
                                  .map((line, i) => (
                                    <div key={i}>{line}</div>
                                  ))}
                              </td>

                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${item.activeStatus === "true"
                                  ? "bg-green-100 text-green-800"
                                  : "bg-red-100 text-red-800"
                                  }`}>
                                  {item.activeStatus === "true" ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                <button
                                  className="text-blue-500 hover:text-blue-700 mr-3"
                                  onClick={() => openApprovalModal(item.userId, item.activeStatus)}
                                  title="Change Status"
                                >
                                  <GrStatusInfo size={18} />
                                </button>
                                <button
                                  className="text-gray-500 hover:text-gray-700"
                                  onClick={() => handleEditHomeClick(item.userId, item.addressId)}
                                  title="Edit User"
                                >
                                  <Pencil size={18} />
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                    <div className="text-sm text-gray-700">
                      Page {currentPage + 1} of {pageCount || 1}
                    </div>
                    <div className="flex-1 flex justify-end">
                      <Pagination
                        currentPage={currentPage}
                        pageCount={pageCount}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {activeTab === 1 && (
            <BankDetails />
          )}
          {activeTab === 3 && (
            <Project />
          )}
        </div>
      )}

      {/* Using GlassmorphicModal for Edit Community Details */}
      <GlassmorphicModal
        isOpen={showcommunityForm}
        onClose={handleAddcommunityClick}
        title="Edit Community Details"
        size="lg"
      >
        <EditCommunityDetails
          initialData={communityData}
          onSubmit={handleEditCommunityDetails}
          onCancel={handleAddcommunityClick}
        />
      </GlassmorphicModal>

      {/* Using GlassmorphicModal for Add Home */}
      <GlassmorphicModal
        isOpen={showAddHome}
        onClose={handleAddHomeClick}
        title="Add New Home"
        size="lg"
      >
        <AddHome onCancel={handleAddHomeClick} />
      </GlassmorphicModal>

      {/* Using GlassmorphicModal for Edit Home */}
      <GlassmorphicModal
        isOpen={showEditHome}
        onClose={() => setShowEditHome(false)}
        title="Edit User Details2"
        size="lg"
      >
        <EditHome
          userId={editingUserId}
          addressId={editingAddressId}
          onHide={handleHideEditHome}
        />
      </GlassmorphicModal>

      {/* Using GlassmorphicModal for Delete Confirmation */}
      <GlassmorphicModal
        isOpen={showDeleteModal}
        onClose={closeDeleteModal}
        title="Confirm Delete"
        size="sm"
        footer={deleteModalFooter}
      >
        <p className="text-gray-700">
          Are you sure you want to delete this user? This action cannot be undone.
        </p>
      </GlassmorphicModal>

      {/* Using GlassmorphicModal for Member Approval */}
      <GlassmorphicModal
        isOpen={showApprovalModal}
        onClose={closeModal}
        title="Member Approval"
        size="sm"
        footer={approvalModalFooter}
      >
        <p className="text-gray-700">
          Are you sure you want to update the status of this member?
        </p>
      </GlassmorphicModal>

      {/* Using GlassmorphicModal for Edit Member Role */}
      <GlassmorphicModal
        isOpen={editMemberRoleModal}
        onClose={closeModal}
        title="Remove Board Member Role"
        size="sm"
        footer={memberRoleModalFooter}
      >
        <p className="text-gray-700">
          Are you sure you want to remove this board member from their role?
        </p>
      </GlassmorphicModal>
    </div>
  );
};

export default CommunityDetails;